import { HttpService, Repository, RepositoryBase, TaggedUrl, Tags, Weaver } from '@skylab-shared/core';
import { AccountancyCreateDTO, AccountancyModel, DataExchangeKind } from '@skylab-shared/dataModel';
import { MS_PER_MINUTE, extractFilenameFromHeaders, fillPlaceholders } from '@skylab-shared/utils';
import { saveAs } from 'file-saver-es';
import { AccountancyBO } from './accountancy.bo';

@Repository({
    boType: AccountancyBO,
    apiController: TaggedUrl.join('accounting', [Tags.Api]),
    customSaveRequestTimeout: 300 * 1000,
    dto: {
        get: null,
        update: AccountancyCreateDTO
    }
})
export class AccountancyRepositoryBase extends RepositoryBase<AccountancyBO, AccountancyModel, null, AccountancyCreateDTO> {
    private static DownloadFileTimeout = 3 * MS_PER_MINUTE;

    public constructor(
        http: HttpService,
        private readonly weaver: Weaver
    ) {
        super(http);
    }

    protected createBO(): AccountancyBO {
        return new AccountancyBO(this.weaver);
    }

    protected fromPlainObjectAsync(): never {
        throw new Error(`Unsupported`);
    }

    protected async preparePlainObjectAsync(model: AccountancyModel): Promise<AccountancyCreateDTO> {
        return {
            kind: model.dataExchangeKind === DataExchangeKind.JPK_VAT
                ? model.dataExchangeSubkind
                : model.dataExchangeKind === DataExchangeKind.PackageOfDocuments
                    ? model.dataExchangeSubkind
                    : model.dataExchangeKind,
            from: model.period_From,
            to: model.period_To,
            purchaseSelection: model.purchaseDocumentsDateSelector,
            salesSelection: model.salesDocumentsDateSelector,
            sentDocumentsFiltering: model.sentDocumentsFiltering,
            ids: model.objectIds,
            parameters: model.parameters,
        };
    }

    // ACCOUNTANCY

    public async downloadDocumentAsync(id: number, options: { compress: boolean, password?: string }): Promise<void> {
        const urlPattern = TaggedUrl.join(`accounting/:id/attachments`, [Tags.Api]);
        const url = fillPlaceholders(urlPattern, { id: id });
        try {
            const response = await this.$http.post<Blob>(url, {
                compress: options.compress,
                password: options.password
            }, {
                responseType: 'blob',
                timeout: AccountancyRepositoryBase.DownloadFileTimeout
            });

            const filenames = extractFilenameFromHeaders(response);
            if (filenames) saveAs(response.data, filenames);
        } catch (err) {
            this.logger.error(err);
        }
    }
}
